import { captureException } from '@sentry/react';
import { ZodError } from 'zod';

import { apiClient } from '@f/api-client';

export async function fetchConfig() {
  try {
    const result = await apiClient.config.fetchConfig();

    if (result.status !== 200) {
      throw new Error(result.body as string);
    }

    return result.body;
  } catch (error) {
    if (error instanceof ZodError) {
      captureException(error);
    }
    throw error;
  }
}
